export { Contact } from './libs/contact-list';
